import React from "react";

// Skeleton components for conversation loading
const Skeleton = ({
  className = "",
  variant = "rectangular",
  width,
  height,
  animate = true,
}) => {
  const baseClasses = "bg-gray-700 rounded";
  const variantClasses = {
    text: "h-4",
    circular: "rounded-full",
    rectangular: "h-4",
  };

  const animationClass = animate ? "animate-pulse" : "";
  const widthClass = width ? `w-${width}` : "";
  const heightClass = height ? `h-${height}` : "";

  const classes = [
    baseClasses,
    variantClasses[variant],
    animationClass,
    widthClass,
    heightClass,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return <div className={classes} style={{ width, height }} />;
};

const ConversationCardSkeleton = () => (
  <div className="animate-pulse rounded-lg border border-gray-800 bg-gray-900 p-6">
    <div className="mb-4 flex items-start justify-between">
      <div className="flex items-center space-x-3">
        <Skeleton className="h-12 w-12 rounded-full" />
        <div>
          <Skeleton className="mb-2 h-5 w-32" />
          <Skeleton className="h-4 w-24" />
        </div>
      </div>
      <Skeleton className="h-6 w-16 rounded-full" />
    </div>

    <div className="mb-4 space-y-3">
      <Skeleton className="h-4 w-full" />
      <Skeleton className="h-4 w-3/4" />
    </div>

    <div className="flex items-center justify-between">
      <div className="flex items-center space-x-4">
        <Skeleton className="h-4 w-20" />
        <Skeleton className="h-4 w-16" />
      </div>
      <Skeleton className="h-8 w-24 rounded-lg" />
    </div>
  </div>
);

const ConversationsGridSkeleton = ({ count = 10 }) => (
  <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
    {Array.from({ length: count }).map((_, index) => (
      <ConversationCardSkeleton key={index} />
    ))}
  </div>
);

export { Skeleton, ConversationCardSkeleton, ConversationsGridSkeleton };
